module.exports = __webpack_public_path__ + "static/img/bmb-footer-logo.4a65e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bmb-footer-logo.png
// module id = jwJR
// module chunks = 1